import { ConditionCastTypeSelect } from 'ui/queryBuilder';
import { CastType } from 'modules/queryBuilder/types';
import { ConditionSingleValueSelectProps } from 'ui/queryBuilder/types';
import { useComparatorState } from 'modules/queryBuilder/hooks/condition';
import { MatchesCatalogComparator } from '../../types';

export const CustomConditionCastTypeSelect = (props: ConditionSingleValueSelectProps<CastType>) => {
  const { comparator } = useComparatorState();
  if (comparator !== MatchesCatalogComparator.MATCHES_CATALOG_DATA) {
    return <ConditionCastTypeSelect {...props} />;
  }
};
